module.exports = __webpack_public_path__ + "img/drsepsis.3a7557c8.png";